export default "__VITE_ASSET__OL5EFY3z__"